export default __webpack_public_path__ + "static/media/21_TopLeftSquares_Top.72d65493.mp4";